module.exports.BLOG_POSTS_PER_PAGE = 18
module.exports.BLOG_POSTS_FIRST_PAGE_LENGTH = 17 // 5 posts are taken to hero section - we need one less blog post to keep the grid consistent
module.exports.BLOG_ARTICLE_MAX_WIDTH = 736
